// test2601
(2601 && 0);
